export default __webpack_public_path__ + "island4.e53bdc44d3bb9f737a7ee267469c86fd.png";